<template>
<div class="">
    <PageBreadcrumb :pagetitle="info.title"/>
    <!-- Location -->
    <section class="pt-0 pb-5 filterSec">
        <div class="container">
            <div class="row">
                <div class="col-lg-3">
                    <div class="filterArea">
                        <div class="filter-title collapsed" data-toggle="collapse" data-target="#filter">Filter Location</div>
                        <div class="filter_option_list collapse" id="filter">
                            <div class="styled-form__field">
                                <label class="filter__label">
                                    <input type="radio" name="location" class="styled-form__input--radio" v-model="selected" value="all">
                                    <span>All of Australia</span>
                                </label>
                            </div>
                            <div class="styled-form__field" v-for="country in countries" :key="country">
                                <label class="filter__label">
                                    <input type="radio" name="location" class="styled-form__input--radio" :value="country" v-model="selected">
                                    <span>{{ countryFullName(country) }}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-9">
                    <div class="club__list pt-md-5">
                        <div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
                            <h4 class="club__title mb-0" v-if="filteredLocations.length === 1">{{ filteredLocations.length }} assembly found</h4>
                            <h4 class="club__title mb-0" v-else>{{ filteredLocations.length }} assemblies found</h4>
                            <div class="assembly">
                                <input type="text" name="search" v-model="search" placeholder="Start typing the name of your assembly">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6 col-lg-4" v-for="location in paginedLocations" :key="location.nid">
                                <div class="assembly__content-tile">
                                    <a href="#">
                                        <div class="assembly__content-tile-title text-danger author-title">{{ location.title }}</div>
                                        <div class="assembly__content-tile-suburb">{{ location.field_address_address_line1 }}, {{ location.field_address_address_line2 }}, {{ location.field_address_locality }}, {{ location.field_address_postal_code }}, {{ location.field_domain_access[0].toUpperCase() }}</div>
                                        <div class="assembly__content-tile-suburb"><b>Contacts</b> </div>
                                        <div class="assembly__content-tile-suburb"> {{ location.field_phone }} </div>
                                    </a>
                                </div>
                            </div>
                            <div class="col-12 col-md-12">
                                <ul class="pagination">
                                    <li class="" v-if="page != 1" @click="page--">
                                        <a href="#" class="pagination__link">Prev</a>
                                    </li>
                                    <li v-for="pageNumber in pages.slice(page-1, page+maxPages)" @click="page = pageNumber" :key="pageNumber" :class="{'active': page === pageNumber}">
                                        <a href="#" class="pagination__link">{{ pageNumber }}</a>
                                    </li>
                                    <li class="" v-if="page < pages.length" @click="page++">
                                        <a href="#" class="pagination__link">Next</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- End Location -->
</div>
</template>

<script>
    import PageBreadcrumb from '@/components/PageBreadcrumb';
    import axios from "axios";

    export default {
        name: 'Location',
        data () {
            return {
                info: { title : 'Locate an assembly' },
                locations: [],
                filterCountries: [],
                countries: [],
                search: '',
                page: 1,
                itemsPerPage: 9,
                pages: [],
                maxPages:3,
                selected: "all",
            }
        },
        components:{
            PageBreadcrumb
        },
        watch: {
            search: function(){
                this.pages = [];
            },
            selected: function(){
                this.pages = [];
            },
            filteredLocations () {
                this.setPages();
            }
        },
        computed:
        {
            filteredLocations:function()
            {
                var self=this;
                if(self.selected !== 'all'){
                    return this.locations.filter(
                    function(location)
                        {
                            if(location.field_domain_access.includes(self.selected)){
                                return location.title.toLowerCase().indexOf(self.search.toLowerCase())>=0;
                            }else{
                                return "";
                            }

                        }
                    );
                }else{
                    return this.locations.filter(
                    function(location)
                        {
                            return location.title.toLowerCase().indexOf(self.search.toLowerCase())>=0;
                        }
                    );
                }
            },
            paginedLocations() {
              return this.paginate(this.filteredLocations)
            }
        },
        methods: {
            countryFullName: function(countrycode){
                if (countrycode == 'act') return "Australian Capital Territory"
                if (countrycode == 'nsw') return "New South Wales"
                if (countrycode == 'nt') return "Northern Province"
                if (countrycode == 'qld') return "Queensland"
                if (countrycode == 'sa') return "South Australia"
                if (countrycode == 'tas') return "Tasmania"
                if (countrycode == 'vic') return "Victoria"
                if (countrycode == 'wa') return "Western Australia"
                return "all"
            },
            filterData : function (item) {
                if(this.countries.indexOf(item) < 0){
                    this.countries.push(item)
                }
            },
            setPages () {
                let numberOfPages = Math.ceil(this.filteredLocations.length / this.itemsPerPage);
                for (let index = 1; index <= numberOfPages; index++) {
                    this.pages.push(index);
                }
            },
            paginate(filteredLocations) {
                let from = (this.page * this.itemsPerPage) - this.itemsPerPage;
                let to = (this.page * this.itemsPerPage);
                return filteredLocations.slice(from, to)
            },
        },
        mounted () {
            axios
                .get('https://api.fifmi.org.au/api/assembly')
                .then(result => {
                    this.locations = result.data
                    for (var i = 0; i < result.data.length; i++) {
                        result.data[i].field_domain_access.forEach(this.filterData)
                    }
                });
        }
    }
</script>
